export const STATUSES = [
  { value: "awaiting_sample", label: "Awaiting Sample Submission" },
  { value: "awaiting_approval", label: "Awaiting Approval" },
  { value: "approved", label: "Approved" },
  { value: "ordered", label: "Ordered" },
  { value: "shipped", label: "Shipped" },
  { value: "in_transit", label: "In Transit" },
  { value: "delivered", label: "Delivered" },
];

export const PRIORITIES = [
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
  { value: "urgent", label: "Urgent" },
];

export const ROLES = [
  { value: "project_manager", label: "Project Manager" },
  { value: "contractor", label: "Contractor" },
  { value: "admin", label: "Admin" },
];

export const STATUS_INDEX = STATUSES.reduce((m, s, i) => ({ ...m, [s.value]: i }), {});
export const STATUS_LABEL = STATUSES.reduce((m, s) => ({ ...m, [s.value]: s.label }), {});
export const PRIORITY_LABEL = PRIORITIES.reduce((m, p) => ({ ...m, [p.value]: p.label }), {});
